import styled from '@emotion/styled';

export const Main = styled.main`
  position: relative;
  top: 100px;
`;
